import Vue from 'vue'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole } from '@sentry/integrations'

if (process.env.NODE_ENV !== 'development') {
  // eslint-disable-line
  Sentry.init({
    Vue,
    dsn: 'https://6e172e46843a4854bb029a2f87827bd3@o1037169.ingest.sentry.io/6004872',
    integrations: [
      new Integrations.BrowserTracing(),
      new CaptureConsole({
        levels: ['error']
      })
    ],
    trackComponents: true,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}
